// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLastYearDataButton_root__kYqjz","text":"PlasmicLastYearDataButton_text__AVfck"};